import { render, staticRenderFns } from "./OldTutoringCollective.vue?vue&type=template&id=e3a00f48&scoped=true"
import script from "./OldTutoringCollective.vue?vue&type=script&lang=js"
export * from "./OldTutoringCollective.vue?vue&type=script&lang=js"
import style0 from "./OldTutoringCollective.vue?vue&type=style&index=0&id=e3a00f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a00f48",
  null
  
)

export default component.exports